import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-17142 — the day each invoice was last added up into
 * `sales_summary_line_day`. When an invoice changes, the summary refresh
 * rebuilds its current day; when its date moved, this row names the old day,
 * which must be rebuilt too or the invoice would be counted on both.
 *
 * Written with the summary rows of a day, in the same transaction: the rows
 * of the days being rebuilt are deleted and the day's invoices written again.
 * No foreign key to `invoice`, so an invoice can still be deleted outright;
 * the nightly re-check finds rows whose invoice is gone and rebuilds their
 * day.
 *
 * Not audited (`auditable: false`): a derived index rebuilt with the summary.
 *
 * SM1 exposure: none. SM1 names no such table.
 */
@Entity('sales_summary_invoice_day_map', {}, { auditable: false })
@Index('sales_summary_invoice_day_map__fk_invoice__id', ['fkInvoiceId'], {
	unique: true,
})
@Index('sales_summary_invoice_day_map__date', ['date'])
export class SalesSummaryInvoiceDayMapEntity extends BaseEntity {
	/** `invoice._id`. */
	@Column('int', { name: 'fk_invoice__id', unsigned: true })
	public fkInvoiceId!: number;

	/** The invoice date the summary last read this invoice under. */
	@Column('date', { name: 'date' })
	public date!: string;
}
